import * as React from "react"
import type { IconProps } from "../types"

const Refresh = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={color}
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path d="M7.04284 17C8.323 18.2349 10.0881 19 12 19C15.866 19 19 15.866 19 12C19 11.7028 18.9815 11.4104 18.9458 11.1237L20.9304 10.8763C20.9764 11.2448 21 11.6199 21 12C21 16.9706 16.9706 21 12 21C9.72477 21 7.60877 20.1546 6 18.7559V21H4V15H10V17H7.04284Z"/>
        <path d="M5 12C5 12.2972 5.01846 12.5896 5.05421 12.8763L3.06958 13.1237C3.02362 12.7552 3 12.3801 3 12C3 7.02944 7.02944 3 12 3C14.2808 3 16.4015 3.84954 18.0117 5.25427V3H20.0117V9H14.0117V7H16.9572C15.677 5.76515 13.9119 5 12 5C8.13401 5 5 8.13401 5 12Z" />
      </svg>
    )
  }
)
Refresh.displayName = "Refresh"

export default Refresh